import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_enclnl0j: FaireBrandEntity = {
  token: "b_enclnl0j",
  type: "brand",
  name: "Heliotrope",
  avatarUrl:
    "https://cdn.faire.com/fastly/5238b3a15aaf5685d7498c37ad50348f4f84f6c6e487c10653a5b16e381c8a45.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d38eddc58198427225fb404ab390c68da8003bf6d6f4f284548cb8325a2823fe.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5238b3a15aaf5685d7498c37ad50348f4f84f6c6e487c10653a5b16e381c8a45.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d38eddc58198427225fb404ab390c68da8003bf6d6f4f284548cb8325a2823fe.jpeg",
  location: "Oakland, CA, USA",
  minimumOrderDollars: 75,
  rating: 4.9,
  reviewCount: 67,
  isInsider: true,
  description:
    "I was looking for a fragrance-free shower gel, and I couldn't find one in all of SF. So I started a company to make personal care products with no artificial perfumes or synthetic colors. We make all our products in small batches in Northern California, using only pure essential oils.\n\nSince the very beginning over 15 years ago, we acted sustainably, offering refills on empties in our shops, and selling in bulk to reduce packaging. By offering almost all our products fragrance free, we allowed our clients to customize their scents on demand - with pure EO’s. And by eliminating fragrance, our product line is - by default - gender-neutral.\n\nA few years ago, we created an organic CBD line - made to our exacting standards - with very high proportions of full spectrum CBD extract, and we're now able to offer this to you here on Faire.\n\nHELIOTROPE - FEEL GOOD IN YOUR SKIN\n\nnote: we've extended our lead times to \"8-10 days\" during the holiday season (to keep the Faire algorithm happy) but our goal is still to ship within our regular 4-7 business days.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:46.279Z",
    importedBy: "entity-db-cli",
  },
};
